// IframeViewerModal.jsx
import React from "react";
import { HiOutlineX } from "react-icons/hi";

const buildViewerUrl = (fileUrl) =>
  `https://docs.google.com/gview?url=${encodeURIComponent(
    fileUrl
  )}&embedded=true`;

const IframeViewerModal = ({ fileUrl, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center">
      <div className="bg-white w-full h-full lg:w-11/12 lg:h-[90vh] lg:rounded-lg flex flex-col shadow-xl">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="font-semibold text-lg">Document Viewer</h3>
          <button onClick={onClose} className="p-2 rounded hover:bg-gray-200">
            <HiOutlineX size={20} />
          </button>
        </div>

        <iframe
          src={buildViewerUrl(fileUrl)}
          title="Document Viewer"
          className="w-full h-full"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default IframeViewerModal;
